var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900.546 99.84h-756.634c-7.488 0-14.371 3.953-18.154 10.461s-3.836 14.467-0.158 21.002l378.317 674.586c3.731 6.614 10.719 10.751 18.338 10.751s14.581-4.084 18.338-10.751l378.317-674.586c3.652-6.535 3.573-14.493-0.158-21.002s-10.666-10.461-18.154-10.461h-0.053zM179.851 142.002h684.754l-342.377 610.5-342.377-610.5zM522.228 310.648c-11.612 0-21.018 9.434-21.018 21.081v210.808c0 11.647 9.405 21.081 21.018 21.081s21.018-9.434 21.018-21.081v-210.808c0-11.647-9.405-21.081-21.018-21.081zM523.542 215.784c-14.51 0-26.272 11.798-26.272 26.351s11.762 26.351 26.272 26.351c14.51 0 26.272-11.798 26.272-26.351s-11.762-26.351-26.272-26.351z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.923fa490f72aa8de746cfd727ad31d22.svg";
export { ForwardRef as ReactComponent };